import LocationMarker from 'icons/LocationMarker';
import LogoHeader from '../LogoHeader';
import NavBar from '../NavBar';
import NavButton from '../NavButton';

export default function OrganizationSubNav({
  organization
}: {
  organization: {
    image?: string;
    fullName?: string;
    name: string;
    genderSport: {
      name: string;
    };
    state: {
      name: string;
    };
    webPath: string;
    webScoresPath: string;
    webStandingsPath: string;
  };
}) {
  return (
    <>
      <LogoHeader
        alt={organization.fullName || organization.name}
        image={organization.image}
        title={organization.fullName || organization.name}
        subTitle={organization.genderSport.name}
        subText={
          <>
            <LocationMarker width={8} height={11} /> {organization.state.name}
          </>
        }
      />
      <NavBar>
        <NavButton href={organization.webPath}>Home</NavButton>
        <NavButton href={organization.webScoresPath}>Scores</NavButton>
        <NavButton href={organization.webStandingsPath}>Standings</NavButton>
      </NavBar>
    </>
  );
}
